import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase/config';
import AIService from './AIService';
import type { App } from '../types/app';
import { ApplePlacement, buildAppleCreativePrompt } from '../utils/appleCreative';

export interface AppleLibraryAsset {
  assetId: string;
  appId: string;
  downloadUrl: string;
  storagePath: string;
  category: string;
  model?: string;
  width?: number;
  height?: number;
  createdAt?: string;
}

class AppleCreativeService {
  async listAssets(appId: string, userId: string): Promise<AppleLibraryAsset[]> {
    const snapshot = await getDocs(query(collection(db, 'appAssets'), where('appId', '==', appId), where('userId', '==', userId)));
    return snapshot.docs.map((doc) => {
      const data = doc.data();
      return { ...data, assetId: doc.id, createdAt: data.createdAt?.toDate?.().toISOString() || '' } as AppleLibraryAsset & { type?: string };
    }).filter((asset) => asset.type === 'image' && asset.downloadUrl && asset.storagePath)
      .sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''));
  }

  async generate(app: App, placement: ApplePlacement, width: number, height: number, direction: string, model: string) {
    const result = await AIService.generateImage(buildAppleCreativePrompt(app, placement, width, height, direction), {
      appId: app.appId, model, assetCategory: `apple/${placement}/source`, size: '1536x1024', n: 1,
    });
    if (!result.images[0]) throw new Error('No image was returned. Please try again.');
    return result.images[0];
  }
}

const appleCreativeService = new AppleCreativeService();
export default appleCreativeService;
